import { render } from "./AddContact.vue?vue&type=template&id=388ebb0a&ts=true"
import script from "./AddContact.vue?vue&type=script&lang=ts"
export * from "./AddContact.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__